<div appFormControl class="email">
  <input
    (blur)="onBlur()"
    (focus)="onFocus()"
    [attr.required]="required"
    [autocomplete]="autocomplete()"
    [formControl]="control"
    [id]="id"
    [name]="name"
    [placeholder]="placeholder()"
    class="email__input"
    inputmode="email"
    type="email"
  />
  @if (control.touched && control.enabled) {
    <app-validity-icon
      [valid]="control.valid"
      class="email__input-check-icon"
    />
  }
</div>
